import service from '@/api';

export const userLoginByCode = () => service.get('/mock');
export const getUserInfo = () => service.get('/user/info');

export const getUserMenus = () =>
  service.get('https://mock.mengxuegu.com/api/user/menus');
// 获取应用信息
export const getAppConfig = () =>
  service.get('/user/public/config?key=app_config');

/**
 *
 * 账号登录
 * */
export const userLogin = async (params): Promise<any> =>
  service.post('/user/login', params);

export const getUserAvatarUrl = async (params): Promise<any> =>
  service.get(`/space/oss/url?oss_key=${params}`);

export const preAuth = async (params): Promise<any> =>
  service.post('/geo/auth/pre', params);

export const getAuthList = async (params): Promise<any> =>
  service.get('/geo/auth', { params });

export const deleteAuth = async (id): Promise<any> =>
  service.delete(`/geo/auth/${id}`);

export const updateAuth = async (id, params): Promise<any> =>
  service.patch(`/geo/auth/${id}`, params);
// 抖音城市选择
export const getCityData = async (): Promise<any> =>
  service.get(`/video/poi/city/data`);
// 编辑城市
export const editAuthCity = async (id: number, data: any): Promise<any> =>
  service.put(`/geo/auth/${id}/area`, data);
